import DocumentsSection from './DocumentsSection'

export default DocumentsSection
